// Relativo de proposito (auditoria de 18/08/2026): antes apontava direto
// pra producao (saas-gl.duckdns.org), o que fazia o frontend rodando em
// localhost:3000 conversar com o backend de PRODUCAO em vez do local,
// mesmo com docker-compose local no ar. Vazio = mesma origem da pagina
// (nginx.conf deste container faz o proxy pro auth/tenant-service certo,
// tanto local quanto em producao -- ver frontend/nginx.conf).
const API_BASE = ''; export default API_BASE;
